import { render, staticRenderFns } from "./StripedCheckbox.vue?vue&type=template&id=13bc7c3e"
import script from "./StripedCheckbox.vue?vue&type=script&lang=js"
export * from "./StripedCheckbox.vue?vue&type=script&lang=js"
import style0 from "./StripedCheckbox.vue?vue&type=style&index=0&id=13bc7c3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports